import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { NavigationProvider } from './providers/NavigationContext';
import { ScannerSettingsProvider } from './providers/ScannerSettingsContext';

const baseUrl =
  document.getElementsByTagName('base')[0]?.getAttribute('href') || '/';

const root = createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter basename={baseUrl}>
    <NavigationProvider>
      <ScannerSettingsProvider>
        <App />
      </ScannerSettingsProvider>
    </NavigationProvider>
  </BrowserRouter>
);

serviceWorkerRegistration.unregister();
reportWebVitals();